module.exports = __webpack_public_path__ + "static/media/riskAge65.124d041f.mp3";